import Logger from '@noths/logger/build/client';
import Config from '../utils/Config';

const whitelistUrls = [
  /https?:\/\/(.*).?(noths|notonthehighstreet).com/,
  /* Uncomment this if testing Sentry in development
  ...(process.env.REACT_APP_ENV === 'staging' ? ['http://localhost:3000'] : []),
  */
];

const ignoreUrls = [
  // Facebook flakiness
  /graph\.facebook\.com/i,
  // Facebook blocked
  /connect\.facebook\.net\/en_US\/all\.js/i,
  // Woopra flakiness
  /eatdifferent\.com\.woopra-ns\.com/i,
  /static\.woopra\.com\/js\/woopra\.js/i,
  // Chrome extensions
  /extensions\//i,
  /^chrome:\/\//i,
  // Other plugins
  /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
  /webappstoolbarba\.texthelp\.com\//i,
  /metrics\.itunes\.apple\.com\.edgesuite\.net\//i,
];

const ignoreErrors = [
  // Random plugins/extensions
  'top.GLOBALS',
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error. html
  'originalCreateNotification',
  'canvas.contentDocument',
  'MyApp_RemoveAllHighlights',
  'http://tt.epicplay.com',
  "Can't find variable: ZiteReader",
  'jigsaw is not defined',
  'ComboSearch is not defined',
  'http://loading.retry.widdit.com/',
  'atomicFindClose',
  // Facebook borked
  'fb_xd_fragment',
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
  // reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268
  'bmi_SafeAddOnload',
  'EBCallBackMessageReceived',
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  'conduitPage',

  // preSignup lambda - User already exists
  'UsernameExistsError',
];

export const setup = () => {
  try {
    const amplifyLogLevel = window.localStorage.getItem('amplifyLogLevel');
    if (amplifyLogLevel) {
      console.log('CONFIG:', Config.get()); // eslint-disable-line no-console
      window.LOG_LEVEL = amplifyLogLevel;
    }
  } catch (e) {
    // We don't care, it's purely for debugging purposes in different environments
  }

  Logger.setup({
    environment: process.env.REACT_APP_ENV,
    clientKey: '54d7571a9cbd4a2895a12f9e980cd07b',
    projectId: '416913',
    options: {
      release: process.env.REACT_APP_VERSION,
      ignoreErrors,
      whitelistUrls,
      ignoreUrls,
    },
  });
};
